/**
 * Which outside services are connected. A service that is off says "not
 * connected yet" and what it waits for, rather than a feature failing quietly.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Card, Pill } from './ui';

export interface Connection {
  key: string;
  label: string;
  connected: boolean;
  note: string;
}

export function useConnections(path: '/platform/connections' | '/credentials/connections') {
  return useQuery({ queryKey: ['connections', path], queryFn: () => api.get<{ connections: Connection[] }>(path), staleTime: 60_000 });
}

export function ConnectionsCard({ path }: { path: '/platform/connections' | '/credentials/connections' }) {
  const query = useConnections(path);
  const rows = query.data?.connections ?? [];
  if (rows.length === 0) return null;
  return (
    <Card title="Services" subtitle="What is switched on, and what is waiting.">
      <ul className="divide-y divide-hairline" data-testid="connections">
        {rows.map((row) => (
          <li key={row.key} className="flex flex-wrap items-center justify-between gap-2 py-2.5">
            <div className="min-w-0">
              <p className="text-[14px] font-medium text-navy">{row.label}</p>
              <p className="text-[12.5px] text-[#5b6b7c]">{row.note}</p>
            </div>
            {row.connected ? <Pill className="bg-mint text-forest">Connected</Pill> : <Pill className="bg-[#eceae4] text-[#5b6b7c]">Not connected yet</Pill>}
          </li>
        ))}
      </ul>
    </Card>
  );
}
